const SubmenuOverlay = () => {

    const menuItems = document.querySelectorAll('.header__item--parent');
    const overlay = document.querySelector('.submenu__overlay');

    Array.from(menuItems).forEach((menuItem) => {

        menuItem.addEventListener('mouseover', function () {
            overlay.classList.add('submenu__overlay--active');
        });
    
        menuItem.addEventListener('mouseout', function(){
            overlay.classList.remove('submenu__overlay--active');
        });
    });
}

export default SubmenuOverlay;